import * as React from 'react';
const FeriteIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <rect
      width={87.66}
      height={30.62}
      x={56.17}
      y={84.69}
      className="prefix__cls-2"
      rx={10.8}
      ry={10.8}
      transform="rotate(-45 100 99.998)"
    />
    <rect
      width={23.26}
      height={17.37}
      x={88.37}
      y={91.31}
      className="prefix__cls-2"
      rx={6.53}
      ry={6.53}
      transform="rotate(-45 100 99.998)"
    />
    <path
      d="M71.57 120.26c.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06-.04.07-.01.17.06.2.07.04.17.01.2-.06M79.94 128.63c.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06-.04.07-.01.17.06.2.07.04.17.01.2-.06M80.52 120.03c.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06-.04.07-.01.17.06.2.07.04.17.01.2-.06M82.84 112.28c.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06-.04.07-.01.17.06.2.07.04.17.01.2-.06M88.28 117.72c.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06-.04.07-.01.17.06.2.07.04.17.01.2-.06M128.29 79.88c-.04.07-.01.17.06.2.07.04.17.01.2-.06.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06M119.92 71.51c-.04.07-.01.17.06.2.07.04.17.01.2-.06.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06M119.34 80.1c-.04.07-.01.17.06.2.07.04.17.01.2-.06.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06M117.02 87.86c-.04.07-.01.17.06.2.07.04.17.01.2-.06.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06M111.58 82.42c-.04.07-.01.17.06.2.07.04.17.01.2-.06.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06"
      className="prefix__cls-1"
    />
  </svg>
);
export default FeriteIcon;
